var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isAdmin)?_c('Head_Modules'):_vm._e(),_c('router-view'),(!_vm.isAdmin)?_c('Foot_Modules'):_vm._e(),(!_vm.isAdmin)?_c('OnlineCustomer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }